import React from 'react';
import Icon from 'app/components/base/Icon';
import HoverableDropdown from 'app/components/base/HoverableDropdown';
import classnames from 'classnames';

import style from './style.css';

const HelperTooltip = ({ hint, direction, className, iconClassName }) => (
  <HoverableDropdown
    axis="end"
    direction={direction}
    className={classnames(style.hoverableDropdown, className)}
    origin={
      <Icon
        inline
        interactive
        family="stamp"
        className={classnames(style.icon, iconClassName)}
      >
        ?
      </Icon>
    }
  >
    {hint}
  </HoverableDropdown>
);

// TODO: move to Flow types
// HelperTooltip.propTypes = {
//   hint: PropTypes.any,
//   direction: PropTypes.string,
//   className: PropTypes.string,
//   iconClassName: PropTypes.string
// };

HelperTooltip.defaultProps = {
  direction: 'bottom',
};

export default HelperTooltip;
